import React from 'react';

import { ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';
import { FormInputValidation } from '@candu-ai/forms/document-types';

interface Props {
  validation?: FormInputValidation[];
  setProps: (props: Record<string, any>) => void;
}

export const EmailValidation = React.memo(({ validation, setProps }: Props) => {
  const emailValidationIndex = validation && validation.findIndex((rule) => rule.type === 'email');
  const hasEmailValidation =
    validation && typeof emailValidationIndex !== 'undefined' && emailValidationIndex > -1;

  const onToggleValidation = () => {
    const newValidation = [...(validation || [])];
    if (hasEmailValidation) {
      // @ts-expect-error   we know that emailValidationIndex is not undefined here
      newValidation.splice(emailValidationIndex, 1);
      setProps({ validation: newValidation });
    } else {
      newValidation.push({ type: 'email', message: 'Invalid email' });
      setProps({ validation: newValidation });
    }
  };

  return (
    <ValueGroup>
      <ValueBox label="Validate email">
        <ValueToggle
          toggleGroup="text-input-validate-email"
          onClick={onToggleValidation}
          isActive={hasEmailValidation}
        />
      </ValueBox>
    </ValueGroup>
  );
});
